module.exports = __webpack_public_path__ + "app-static/img/21.7c8d27be.png";